<template>
  <header>
    <h1 class="a11y-hidden">웨이브</h1>
    <div class="header-top editorpick-title">
      <button class="btn-back" type="button">
        <span class="a11y-hidden">뒤로 가기</span>
        <span class="icon-back" @click.prevent="close"><BackButton/></span>
      </button>
      <div class="hd-title-wrap">
        <h2 class="hd-title" v-html="getTitleText"></h2>
        <p class="editorpick-top-txt">
          <span v-for="(title, index) in getFilteredTitle(titleList)" v-html="title.text" :key="'title'+index"></span>
        </p>
        <button class="like-btn" @click="likeTheme" v-if="hasHeart">
          <LikeButtonOn v-if="isOn"/>
          <LikeButtonOff v-else/>
        </button>
      </div>
    </div>
  </header>
</template>

<script>
import { get } from 'lodash'
import { convertSpecialSymbols } from '@/common/directives'
import BackButton from '@/assets/svg/common/ic_gnb_back_w.svg'
import LikeButtonOn from '@/assets/svg/common/ic-detail-small-like-on.svg'
import LikeButtonOff from '@/assets/svg/common/ic-detail-small-like-off.svg'
import { MyPooqService } from '@/common/api/api.service'
import utils from '@/common/util/utils'
import { MSG_COMPLETE_ADD_ZZIM_EDITOR_PICK, MSG_COMPLETE_DELETE_ZZIM_EDITOR_PICK } from '@/common/constant'

// TODO: props로 textList 받아서 각 행에 맞게 스타일 맞춰서 넣어야 됨 그리고 스크롤에 따른 사이즈 변경
// TODO: svg 백그라운드로 사용 가능하지 확인해서 처리 하던지 z-index로 그냥 두던지
export default {
  name: 'ViewMoreEditorPickHeader',
  props: ['titleList', 'topButtonList', 'closeFn'],
  computed: {
    getTitleText () {
      const title = get(this.titleList, ['0', 'text'], '').replace('<', '&lt;').replace('>', '&gt;')
      return convertSpecialSymbols(title)
    }
  },
  components: {
    BackButton,
    LikeButtonOn,
    LikeButtonOff
  },
  data () {
    return {
      isOn: false,
      hasHeart: false,
      themeCode: ''
    }
  },
  methods: {
    getFilteredTitle (list) {
      let resTitle = []
      for (let i = 0; i < list.length; i++) {
        if (i !== 0) {
          resTitle.push(list[i])
        }
      }
      return resTitle
    },
    close () {
      this.closeFn()
    },
    likeTheme () {
      if (utils.cookies.getCredential() === 'none' && utils.cookies.getDevice() === 'mobile') {
        this.$router.replace(`/login?referer=${encodeURIComponent(location.href.replace(location.origin, ''))}`)
      } else {
        if (this.isOn) {
          MyPooqService.deleteZzim({
            contentids: [this.themeCode],
            contenttype: 'theme',
            delalarm: 'y'
          }).then(({ data }) => {
            if (data.resultcode === '200') {
              this.$toast({ message: MSG_COMPLETE_DELETE_ZZIM_EDITOR_PICK })
              this.$nextTick(() => {
                this.isOn = false
              })
            }
          })
        } else {
          MyPooqService.setZzim({
            contentid: this.themeCode,
            contenttype: 'theme',
            addalarm: 'y'
          }).then(({ data }) => {
            if (data.resultcode === '200') {
              this.$toast({ message: MSG_COMPLETE_ADD_ZZIM_EDITOR_PICK })
              this.$nextTick(() => {
                this.isOn = true
              })
            }
          })
        }
      }
    },
    init () {
      const zzimButton = this.topButtonList.filter((button) => { return get(button, 'buttontype', '') === 'zzim' })[0]
      const eventList = get(zzimButton, ['event_list'], [])
      this.hasHeart = eventList.length > 0
      if (this.hasHeart) {
        this.isOn = get(zzimButton, 'buttonstate', 'n') !== 'n'
        const onRadioEvent = eventList.filter((event) => { return event.type === 'on-radio' })[0]
        const url = get(onRadioEvent, 'url', '')
        const themeCode = url.split('/').pop()
        this.themeCode = isNaN(themeCode) ? get(onRadioEvent, ['bodyjson', 'contentids', '0'], '') : themeCode
      }
    }
  },
  created () {
    this.init()
  },
  watch: {
    titleList () {
      this.init()
    }
  }
}
</script>

<style scoped>
  .editorpick-title {
    position: relative;
    height: auto;
    padding: 70px 20px 20px;
    background-color: #252525;
  }

  .editorpick-title .hd-title-wrap {
    padding-right: 38px;
  }

  .editorpick-title .hd-title {
    font-size: 20px;
    line-height: 28px;
    color: #fff;
    text-align: left;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  .editorpick-top-txt {
    margin-top: 4px;
  }

  .editorpick-top-txt span {
    display: block;
    font-size: 14px;
    line-height: 18px;
    color: #a5a5a5;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
  .like-btn {
    display: flex;
    justify-content: center;
    align-items: center;
    position: absolute;
    right: 10px;
    bottom: 10px;
    width: 38px;
    height: 38px;
    z-index: 100;
  }
</style>
